"use strict";
/* globals module */
/**
 * @module mediaGallerySettingsClient
 * @description  Media Gallery Settings Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Settings Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var MediaGallerySettingsClient = /** @class */ (function () {
    function MediaGallerySettingsClient(mediaGallerySettingsRoute, apiClient) {
        this.mediaGallerySettingsRoute = mediaGallerySettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaGallerySettingsClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaGallerySettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns media gallery settings resource.
     * @method
     * @returns A promise that is resolved once the get action has been performed.
     * @example mediaGallerySettingsClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MediaGallerySettingsClient.prototype.get = function () {
        return this.apiClient.get(this.routeDefinition.get());
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates the media gallery settings resource.
     * @method
     * @param data A media gallery settings object used to update media gallery settings in the system.
     * @returns A promise that is resolved once the update action has been performed.
     * @example mediaGallerySettingsClient.update(mediaGallerySettings)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MediaGallerySettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    MediaGallerySettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaGallerySettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaGallerySettingsRoute !== "undefined" && _1.MediaGallerySettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaGallerySettingsClient);
    return MediaGallerySettingsClient;
}());
exports.MediaGallerySettingsClient = MediaGallerySettingsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
